import { HttpClient } from "@angular/common/http";
import { Component, Input } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { EMPTY, catchError, map, tap } from "rxjs";
import { isDefined, isEmptyString } from "../helpers";

// moo-thumbnail component can not eb sued as tehre are 4 requiremtns that ahve diferent behaviour then the component provides 

@Component({
  selector: "au-thumbnail-image",
  templateUrl: "./protected-image-thumbnail.component.html",
  styleUrls: ["./protected-image-thumbnail.component.scss"],
})
export class ThumbnailImageComponent {

  private readonly PngBase64Prefix = "iVBORw0KGgo";
  private readonly JpegBase64Prefix = "/9j/";
  private readonly Gif87aBase64Prefix = "R0lGODdh";
  private readonly Gif89aBase64Prefix = "R0lGODlh";

  private readonly PngMimeType = "image/png";
  private readonly JpegMimeType = "image/jpeg";
  private readonly GifMimeType = "image/gif";
  private readonly FallbackMimeType = "application/octet-stream";

  image!: SafeUrl;
  @Input() defaultImageClass: string = "";
  @Input() imageClass: string = "";
  @Input() defaultImage: string = "";
  @Input() set imageUrl(url: string) {
    if (!isEmptyString(url)) {
      this.loadImage(url);
    }
  }

  @Input() set base64Picture(base64: string | null | undefined) {
    if (!base64) {
      return;
    }

    const mimeType = this.detectImageMimeType(base64);
    this.image = this.domSanitizer.bypassSecurityTrustUrl(`data:${mimeType};base64,${base64}`);
  }

  @Input() displayName = "";
  @Input() key = "";

  _size = 32;
  @Input() set size(value: number) {
    this._size = value;
    document.documentElement.style.setProperty("--width-px", value + "px");
  }
  get imageIsLoaded(): boolean {
    return (isDefined(this.image));
  }

  get size(): number {
    return this._size;
  }

  constructor(
    private readonly httpClient: HttpClient,
    private readonly domSanitizer: DomSanitizer) {
    document.documentElement.style.setProperty("--width-px", this.size + "px");
  }

  private loadImage(url: string) {
    this.httpClient
      .get(url, { responseType: "blob" })
      .pipe(
        map(e => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e))),
        tap((data) => {
          this.image = data;
        }),
        catchError(() => EMPTY)
      ).subscribe();
  }

  private detectImageMimeType(base64: string): string {
    switch (true) {
    case base64.startsWith(this.PngBase64Prefix):
      return this.PngMimeType;
    case base64.startsWith(this.JpegBase64Prefix):
      return this.JpegMimeType;
    case base64.startsWith(this.Gif87aBase64Prefix):
    case base64.startsWith(this.Gif89aBase64Prefix):
      return this.GifMimeType;
    default:
      return this.FallbackMimeType;
    }
  }
}
